'use client'

export { CurrencyInput, type CurrencyInputProps } from './CurrencyInput'
